export function normalizeCpf(input: string): string {
  return input.replace(/\D/g, "");
}

/**
 * 11 dígitos, sem sequência de um único dígito repetido.
 * 1º verificador: soma dos 9 primeiros dígitos com pesos 10 a 2, vezes 10, módulo 11 (10 vira 0).
 * 2º verificador: mesmo cálculo com os 10 primeiros dígitos e pesos 11 a 2.
 */
export function isValidCpf(input: string): boolean {
  const cpf = normalizeCpf(input);
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  const digits = cpf.split("").map(Number);
  const check = (len: number) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += (digits[i] ?? 0) * (len + 1 - i);
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };
  return check(9) === digits[9] && check(10) === digits[10];
}

/** "12345678909" vira "123.456.789-09". */
export function formatCpf(input: string): string {
  const c = normalizeCpf(input);
  return `${c.slice(0, 3)}.${c.slice(3, 6)}.${c.slice(6, 9)}-${c.slice(9, 11)}`;
}

/** "12345678909" vira "***.456.789-**". */
export function maskCpf(input: string): string {
  const c = normalizeCpf(input);
  if (c.length !== 11) return "***.***.***-**";
  return `***.${c.slice(3, 6)}.${c.slice(6, 9)}-**`;
}

export function normalizeCnpj(input: string): string {
  return input.replace(/\D/g, "");
}

export function isValidCnpj(input: string): boolean {
  const c = normalizeCnpj(input);
  if (c.length !== 14 || /^(\d)\1{13}$/.test(c)) return false;
  const digits = c.split("").map(Number);
  const calc = (len: number) => {
    const weights =
      len === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < len; i++) sum += (digits[i] ?? 0) * (weights[i] ?? 0);
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };
  return calc(12) === digits[12] && calc(13) === digits[13];
}
